const { eventCategory, eventInitiator, eventType } = require('./print');

module.exports = {
  containsActive: (events) => events.find((event) => !event.canceled && event.started) !== undefined,
  containsNoActive: (events) => events.find((event) => !event.canceled && !event.started) === undefined,
  containsUpcoming: (events) => events.find((event) => !event.canceled && !event.started) !== undefined,
  containsNoUpcoming: (events) => events.find((event) => !event.canceled && !event.started) === undefined,
  eventCategory,
  eventInitiator,
  eventType,
};
